"use strict";
/// <reference path="irep.js"/>

IREP.processors = (function () {
    //var currentPromoDisplaying = 1;
    //var processorIntervalId;
    var init = function (options) {

        
            var currentTallest = 0,
             currentRowStart = 0,
             rowDivs = new Array(),
             $el,
             currentDiv = 0,
             topPosition = 0;

            $('.task').each(function () {

                $el = $(this);
                topPosition = $el.position().top;

                if (currentRowStart != topPosition) {

                    // we just came to a new row.  Set all the heights on the completed row
                    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                        rowDivs[currentDiv].height(currentTallest);
                    }

                    // set the variables for the new row
                    rowDivs.length = 0; // empty the array
                    currentRowStart = topPosition;
                    currentTallest = $el.height();
                    rowDivs.push($el);

                } else {

                    // another div on the current row.  Add it to the list and check if it's taller
                    rowDivs.push($el);
                    currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);

                }

                // do the last row
                for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }

            });
        

        bannerRotator("#slider", 300, 50000, true);


        $(".atomCoreTgl_Atom").click(function () {
            $("#atom_Grid").show();
            $("#coreM_Grid").hide();
            $(".atomCoreTgl_Atom").addClass("yellowSelected");
            $(".atomCoreTgl_coreM").removeClass("yellowSelected");
            
        })
        $(".atomCoreTgl_coreM").click(function () {
            $("#atom_Grid").hide();
            $("#coreM_Grid").show();
            $(".atomCoreTgl_coreM").addClass("yellowSelected");
            $(".atomCoreTgl_Atom").removeClass("yellowSelected");
        })


        $(function () {
            var carousel = $('#slider ul:first-of-type');
            var carouselChild = carousel.find('#slider ul:first-of-type li');
            var clickCount = 0;
            var selector = '#slider';
            var count = $(selector + " li").size(); //get total number of list items
            var itemWidth = carousel.find('li:first').width() + 1;

            carousel.width(itemWidth * carouselChild.length);




            $('.btnNext').click(function () {

                var currentClass = $(selector + " li:visible").attr('rel'); //get the list position of the current image
                var nextClass = $(selector + " li:visible").attr('rel'); //open a new variable for the next class
                if (currentClass == count) { nextClass = 1; } //if you've reached the end of the images... start from number 1 again
                else { nextClass++; } //if not just add one to the last number

                $(selector + " li[rel=" + currentClass + "]").fadeOut(300); //fade out old image
                $("#bannerNav a.active").removeClass('active'); //remove active class from our nav

                $(selector + " li[rel=" + nextClass + "]").fadeIn(300); //fade in new image
                $("#bannerNav a[rel=" + nextClass + "]").addClass('active'); //add new active class to the next nav item


            });

            $('.btnPrevious').click(function () {
                var currentClass = $(selector + " li:visible").attr('rel'); //get the list position of the current image
                var nextClass = $(selector + " li:visible").attr('rel'); //open a new variable for the next class
                if (currentClass == 1) { nextClass = count; } //if you've reached the end of the images... start from number 1 again
                else { nextClass--; } //if not just add one to the last number

                $(selector + " li[rel=" + currentClass + "]").fadeOut(300); //fade out old image
                $("#bannerNav a.active").removeClass('active'); //remove active class from our nav

                $(selector + " li[rel=" + nextClass + "]").fadeIn(300); //fade in new image
                $("#bannerNav a[rel=" + nextClass + "]").addClass('active'); //add new active class to the next nav item

            });

            //function refreshChildPosition() {
            //    carouselChild.each(function () {
            //        $(this).css('left', itemWidth * carouselChild.index($(this)));
            //    });
            //}

            //function refreshChildPositionNext() {
            //    carouselChild.each(function () {
            //        leftVal = parseInt($(this).css('left'));
            //    });
            //}
        });


        currentArkString();

        //rotatePromo();
        //processorIntervalId = window.setInterval(function () { rotatePromo() }, 15000);
        //hideAllPromos();
        $("#1").css("display", "block");
        $("#dot1").addClass("selected");
        $(".trainingScrollBarContainer").css("width", ($("#hidNoOfTrainings").val() * 245) + "px");
        
    };

    $(".mobile_Activities").mCustomScrollbar({
        horizontalScroll:true,
        theme:"dark-thick",
        autoExpandScrollbar:true,
        autoHideScrollbar: false,
        advanced:{autoExpandHorizontalScroll:true}
    })


    


    //var currentSlide = 0;

    //function nextSlide() {

    //    TweenLite.to($slides.eq(currentSlide), 1, { left: "-1913px" } );
        
    //    if (currentSlide < $slides.length - 1) {
    //        currentSlide++;
    //    }
    //    else {
    //        currentSlide = 0;
    //    }

    //    TweenLite.fromTo($slides.eq(currentSlide), 1, { left: "1913px" }, { left: "0px" });

    //    if (window.location.href.toLowerCase().indexOf("processorcomparison") == -1) {
    //        TweenLite.delayedCall(6, nextSlide);
    //    }
    //    else {
    //        TweenLite.delayedCall(7, nextSlide);
    //    }
    //}

    //var rotatePromo = function () {
    //    hideAllPromos();
    //    $("#" + currentPromoDisplaying).css("display", "block");
    //    unselectNavDots();
    //    selectNavDot(currentPromoDisplaying);        

    //    currentPromoDisplaying++;
    //    if ( typeof $("#" + currentPromoDisplaying).val() === "undefined") {
    //        currentPromoDisplaying = 1;
    //    }
    //};


    //var unselectNavDots = function () {
    //    $(".dot").each(function () {
    //        $(this).removeClass("selected");
    //    });
    //};
    //var selectNavDot = function (number) {
    //    $("[id=dot" + number + "]").addClass("selected");
    //};
    //var hideAllPromos = function () {
    //    if (window.location.href.toLowerCase().indexOf("processorcomparison") == -1) {
    //        for (var i = 1; i < 8; i++)
    //            $("#" + i).css("display", "none");
    //    }
    //    else {
    //        for (var i = 1; i < 9; i++)
    //            $("#" + i).css("display", "none");
    //    }
    //}

    var resetChartToDefault = function () {
        $("#i3, #i5, #i7,#corem3,#corem5,#corem7,#celeron,#pentium,#atomx3,#atomx5,#atomx7").removeClass("badgeselected").removeClass("selected");
        
        $("#mobilityAndFunTask").removeClass("selected");
        
        $("#powerfulMobilityTask").removeClass("selected");
        
        $("#productivityTask").removeClass("selected");
        
        $("#premiumPerformanceTask").removeClass("selected");
        
        $("#maximizedPerformanceTask").removeClass("selected");
        
        $("#gamingTask").removeClass("selected");
        
        $("#entertainmentTask").removeClass("selected");
        
        $("#creativityTask").removeClass("selected");
        
        $("#securityTask").removeClass("selected");
        
        $("#touchTask").removeClass("selected");
        
        $("#valueTask").removeClass("selected");
        
        $("#extremeTask").removeClass("selected");
        
        $("#transformTask").removeClass("selected");

        $("#mobilityAndFunTask").removeClass("select");
        $("#powerfulMobilityTask").removeClass("select");
        $("#productivityTask").removeClass("select");
        $("#premiumPerformanceTask").removeClass("select");
        $("#maximizedPerformanceTask").removeClass("select");
        $("#gamingTask").removeClass("select");
        $("#entertainmentTask").removeClass("select");
        $("#creativityTask").removeClass("select");
        $("#securityTask").removeClass("select");
        $("#touchTask").removeClass("select");
        $("#valueTask").removeClass("select");
        $("#extremeTask").removeClass("select");
        $("#transformTask").removeClass("select");

        $("#atomBlueArrow").removeClass("selected");
        $("#i3BlueArrow").removeClass("selected");
        $("#i5BlueArrow").removeClass("selected");
        $("#i7BlueArrow").removeClass("selected");
        $("#pcBlueArrow").removeClass("selected");
        $("#coremBlueArrow").removeClass("selected");
    };

    var selectMobilityAndFunTask = function () {
        $("#mobilityAndFunTask").addClass("selected");
        //$("#mobilityAndFunIcon").removeClass("mobilityAndFunIconYellow").addClass("mobilityAndFunIconWhite");
    };

    var selectPowerfulMobilityTask = function () {
        $("#powerfulMobilityTask").addClass("selected");
        //$("#powerfulMobilityIcon").removeClass("powerfulMobilityIconYellow").addClass("powerfulMobilityIconWhite");
    };

    var selectProductivityTask = function () {
        $("#productivityTask").addClass("selected");
        //$("#productivityIcon").removeClass("productivityIconYellow").addClass("productivityIconWhite");
    };

    var selectPremiumPerformanceTask = function () {
        $("#premiumPerformanceTask").addClass("selected");
       // $("#premiumPerformanceIcon").removeClass("premiumPerformanceIconYellow").addClass("premiumPerformanceIconWhite");
    };

    var selectMaximizedPerformanceTask = function () {
        $("#maximizedPerformanceTask").addClass("selected");
        //$("#maximizedPerformanceIcon").removeClass("maximizedPerformanceIconYellow").addClass("maximizedPerformanceIconWhite");
    };

    var selectGamingTask = function () {
        $("#gamingTask").addClass("selected");
        //$("#gamingIcon").removeClass("gamingIconYellow").addClass("gamingIconWhite");
    };

    var selectEntertainmentTask = function () {
        $("#entertainmentTask").addClass("selected");
        //$("#entertainmentIcon").removeClass("entertainmentIconYellow").addClass("entertainmentIconWhite");
    };

    var selectCreativityTask = function () {
        $("#creativityTask").addClass("selected");
        //$("#creativityIcon").removeClass("creativityIconYellow").addClass("creativityIconWhite");
    };

    var selectSecurityTask = function () {
        $("#securityTask").addClass("selected");
       // $("#securityIcon").removeClass("securityIconYellow").addClass("securityIconWhite");
    };

    var selectTouchTask = function () {
        $("#touchTask").addClass("selected");
        //$("#touchIcon").removeClass("touchIconYellow").addClass("touchIconWhite");
    };

    var selectValueTask = function () {
        $("#valueTask").addClass("selected");
        //$("#valueIcon").removeClass("valueIconYellow").addClass("valueIconWhite");
    };

    var selectExtremeTask = function () {
        $("#extremeTask").addClass("selected");
       // $("#extremeIcon").removeClass("extremeIconYellow").addClass("extremeIconWhite");
    };

    var selectTransformTask = function () {
        $("#transformTask").addClass("selected");
        //$("#transformIcon").removeClass("transformIconYellow").addClass("transformIconWhite");
    };


    $(".task").click(function () {
        var task = $(this).attr('id');
        resetChartToDefault();
        $("#" + task).addClass("select");
        switch (task) {
            case "mobilityAndFunTask":
                $("#atomx3, #atomx5, #atomx7").addClass("selected");
                
                break;
            case "powerfulMobilityTask":
                $("#corem3, #corem5, #corem7").addClass("selected");
                
                break;
            case "productivityTask":
                $("#i3, #i5, #i7").addClass("selected");
                
                break;
            case "premiumPerformanceTask":
                $("#celeron, #pentium").addClass("selected");
                
                break;
            case "maximizedPerformanceTask":
                $("#i3, #i5,#i7,#corem5,#corem7,#atomx5,#atomx7").addClass("selected");
               
                break;
            case "gamingTask":
                $("#i3, #i5,#i7,#corem3,#corem5,#corem7,#atomx5,#atomx7").addClass("selected");
               
                break;
            case "entertainmentTask":
                $("#i3, #i5,#i7,#corem3,#corem5,#corem7,#atomx5,#atomx7").addClass("selected");
                
                break;
            case "creativityTask":
                $("#i3, #i5,#i7,#corem3,#corem5,#corem7").addClass("selected");
                
                break;
            case "securityTask":
                $("#i3, #i5,#i7,#corem3,#corem5,#corem7,#atomx3,#atomx5,#atomx7").addClass("selected");
                
                break;
            case "touchTask":
               
                $("#i7").addClass("selected");
                
                break;
            case "extremeTask":
                $("#i3, #i5,#i7,#corem3,#corem5,#corem7,#atomx3,#atomx5,#atomx7,#celeron,#pentium").addClass("selected");
                
                
                break;
            case "transformTask":
                
                $("#i3, #i5,#i7,#corem3,#corem5,#corem7,#atomx3,#atomx5,#atomx7,#pentium, #celeron").addClass("selected");
                
                break;
            case "valueTask":
                $("#i7").addClass("selected");
                
                
                break;
        }
    });

     
    //$(".dot").click(function () {
    //    clearInterval(processorIntervalId);
    //    hideAllPromos();
    //    $("#" + $(this).attr("id").slice(-1)).css("display", "block");
    //    currentPromoDisplaying = parseInt($(this).attr("id").slice(-1));
    //    unselectNavDots();
    //    selectNavDot(currentPromoDisplaying);
    //    processorIntervalId = window.setInterval(function () { rotatePromo() }, 15000);
    //});

    $("#legalIcon").click(function () {
        $(".text").slideToggle();
        $("html, body").animate({ scrollTop: $(document).height() }, "slow");
    });

    var currentArkString = function () {
        if (window.location.href.toLowerCase().indexOf("processorcomparison") != -1) {
            var cultureCode = IREP.options.user.cultureCode;
            var locale = "";
            var link = "";

            switch (cultureCode) {
                //asmo
                case "en-US":
                    link = "us/en"
                    break;
                    //emea
                case "fr-FR":
                    locale = "fr";
                    link = "fr/fr";
                    break;
                case "de-DE":
                    locale = "de";
                    link = "de/de";
                    break;
                case "it-IT":
                    locale = "it";
                    link = "it/it";
                    break;
                case "nl-NL":
                    locale = "nl";
                    link = "nl/nl";
                    break;
                case "pl-PL":
                    locale = "pl";
                    link = "pl/pl";
                    break;
                case "ru-RU":
                    locale = "ru";
                    link = "ru/ru";
                    break;
                case "es-ES":
                    locale = "es-es";
                    link = "es/es";
                    break;
                case "es-SV":
                    locale = "sv";
                    link = "se/sv";
                    break;
                case "tr-TR":
                    locale = "tr";
                    link = "tr/tr";
                    break;
                case "sv-SE":
                    locale = "sv";
                    link = "se/sv";
                    break;
                case "en-UK":
                    link = "uk/en";
                    break;
                case "en-GB":
                    link = "uk/en";
                    break;
                    //lar
                case "es-MX":
                    locale = "es";
                    link = "xl/es";
                    break;
                case "pt-BR":
                    locale = "pt-br";
                    link = "br/pt";
                    break;
                    //apac
                case "th-TH":
                    locale = "th";
                    link = "th/th";
                    break;
                case "vi-VN":
                    locale = "vi";
                    link = "vn/vi";
                    break;
                case "id-ID":
                    locale = "id";
                    link = "id/id";
                    break;
                case "zh-TW":
                    locale = "zh-TW";
                    link = "tw/zh";
                    break;
                case "ko-KR":
                    locale = "ko";
                    link = "kr/ko";
                    break;
                    //prc
                case "zh-CHS":
                    locale = "zh-cn";
                    link = "cn/zh";
                    break;
                    //IJKK
                case "ja-JP":
                    locale = "ja";
                    link = "jp/ja";
                    break;
            }

            if (link == "") //default value for intel link
            {
                link = "us/en";
            }
            $("#arkUrl").attr("onclick", "window.open ('http://ark.intel.com/" + locale + "', '_blank'); return false;");
            $("#intelUrl").attr("onclick", "window.open ('http://www.intel.com/content/www/" + link + "/processors/processor-numbers.html?iid=prod_core2duo+body_processornumbers', '_blank'); return false;");
            $("#hyper").attr("onclick", "window.open ('http://www.intel.com/content/www/" + link + "/architecture-and-technology/hyper-threading/hyper-threading-technology.html', '_blank'); return false;");
            $("#widi").attr("onclick", "window.open ('https://www-ssl.intel.com/content/www/" + link + "/architecture-and-technology/intel-wireless-display.html?','_blank'); return false;");
            $("#turbo").attr("onclick", "window.open ('https://www-ssl.intel.com/content/www/" + link + "/architecture-and-technology/turbo-boost/turbo-boost-technology.html?','_blank'); return false;");
            $("#overclocking").attr("onclick", "window.open ('http://www.intel.com/content/www/" + link + "/gaming/overclocking-intel-processors.html','_blank'); return false;");
            };
    };

    $(".processor").click(function () {
        var processor = $(this).attr('id');

        resetChartToDefault();

        $("#" + processor).addClass("badgeselected");
        $("#" + processor + "YellowArrow").addClass("selected");

        switch (processor) {
            case "i3":
                selectProductivityTask();
                selectMaximizedPerformanceTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectCreativityTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                break;
            case "i5":
                selectProductivityTask();
                selectMaximizedPerformanceTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectCreativityTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                break;
            case "i7":
                selectProductivityTask();
                selectMaximizedPerformanceTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectCreativityTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                selectTouchTask();
                selectValueTask();
                break;
            case "corem3":
                selectPowerfulMobilityTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectCreativityTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                break;
            case "corem5":
                selectPowerfulMobilityTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectCreativityTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                selectMaximizedPerformanceTask();
                break;
            case "corem7":
                selectPowerfulMobilityTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectCreativityTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                selectMaximizedPerformanceTask();
                break;
            case "celeron":
                selectPremiumPerformanceTask();
                selectExtremeTask();
                selectTransformTask();
                break;
            case "pentium":
                selectPremiumPerformanceTask();
                selectExtremeTask();
                selectTransformTask();
                break;
            case "atomx3":
                selectMobilityAndFunTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();
                break;
            case "atomx5":
                selectMobilityAndFunTask();
                selectMaximizedPerformanceTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();  
                break;
            case "atomx7":
                selectMobilityAndFunTask();
                selectMaximizedPerformanceTask();
                selectGamingTask();
                selectEntertainmentTask();
                selectSecurityTask();
                selectExtremeTask();
                selectTransformTask();

        }

    });

    $("#previous").click(function () {
        previousTraining();
    });

    $("#next").click(function () {
        nextTraining();
    });

    $("#previous").hover(function () {
        $(this).css({ "cursor": "pointer" });
    });

    $("#next").hover(function () {
        $(this).css({ "cursor": "pointer" });
    });

    $(".task").hover(function () {
        if (typeof $(this).attr("id") !== "undefined") {
            $(this).css({ "cursor": "pointer" });
        }
    });

    $(".badge").hover(function () {
        $(this).css({ "cursor": "pointer" });
    });

    return {
        init: init
    };
}());